export default __webpack_public_path__ + "static/media/fhdalogo.8e3300e8.jpg";